require('./bootstrap');
require('@justinribeiro/lite-youtube');
require('./jQuery.print.min');
